import React from 'react';
import { Card, CardContent, Grid, Box, Typography } from '@mui/material';
import { Schedule, CheckCircle, Pending, Cancel, AttachMoney } from '@mui/icons-material';
import { format } from 'date-fns';
import { formatCurrency } from '../../utils/formatters';

const AppointmentsStats = ({
    stats,
    user,
    cardGridProps,
    iconContainerProps,
    textContainerProps,
    t,
    daily = false
}) => (
    <Grid container spacing={3} sx={{ mb: 3 }}>
        {console.log("this is the stats : ", stats)}
        <Grid item xs={12} sm={6} md={3}>
            <Card>
                <CardContent>
                    <Box sx={cardGridProps}>
                        <Box sx={textContainerProps}>
                            <Typography color="textSecondary" gutterBottom>
                                {daily ? t('appointments.dailyTotal') : t('common.total')}
                            </Typography>
                            <Typography variant="h4">
                                {stats.total}
                            </Typography>
                        </Box>
                        <Box sx={{ ...iconContainerProps, color: 'primary.main' }}>
                            <Schedule />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
            <Card>
                <CardContent>
                    <Box sx={cardGridProps}>
                        <Box sx={textContainerProps}>
                            <Typography color="textSecondary" gutterBottom>
                                {daily ? t('appointments.dailyCompleted') : t('appointments.statusCompleted')}
                            </Typography>
                            <Typography variant="h4">
                                {stats.completed}
                            </Typography>
                        </Box>
                        <Box sx={{ ...iconContainerProps, color: 'success.main' }}>
                            <CheckCircle />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
            <Card>
                <CardContent>
                    <Box sx={cardGridProps}>
                        <Box sx={textContainerProps}>
                            <Typography color="textSecondary" gutterBottom>
                                {daily ? t('appointments.dailyPending') : t('appointments.statusPending')}
                            </Typography>
                            <Typography variant="h4">
                                {stats.pending}
                            </Typography>
                        </Box>
                        <Box sx={{ ...iconContainerProps, color: 'warning.main' }}>
                            <Pending />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
            <Card>
                <CardContent>
                    <Box sx={cardGridProps}>
                        <Box sx={textContainerProps}>
                            <Typography color="textSecondary" gutterBottom>
                                {daily ? t('appointments.dailyCancelled') : t('appointments.statusCancelled')}
                            </Typography>
                            <Typography variant="h4">
                                {stats.cancelled}
                            </Typography>
                        </Box>
                        <Box sx={{ ...iconContainerProps, color: 'error.main' }}>
                            <Cancel />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            <Card>
                <CardContent>
                    <Box sx={cardGridProps}>
                        <Box sx={textContainerProps}>
                            <Typography color="textSecondary" gutterBottom>
                                {daily ? t('appointments.dailyUpcoming') : t('appointments.statusUpcoming')}
                            </Typography>
                            <Typography variant="h4">
                                {stats.upcoming}
                            </Typography>
                        </Box>
                        <Box sx={{ ...iconContainerProps, color: 'error.main' }}>
                            <Cancel />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </Grid>

        {user?.userType !== 'radiologist' && (
            <Grid item xs={12} sm={6} md={3}>
                <Card>
                    <CardContent>
                        <Box sx={cardGridProps}>
                            <Box sx={textContainerProps}>
                                <Typography color="textSecondary" gutterBottom>
                                    {daily ? t('appointments.dailyIncome') : t('appointments.totalIncome')}
                                </Typography>
                                <Typography variant="h4">
                                    {formatCurrency(stats.Income)}
                                </Typography>
                            </Box>
                            <Box sx={{ ...iconContainerProps, color: 'success.main' }}>
                                <AttachMoney />
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>

        )}
        {user?.userType !== 'radiologist' && (
            <Grid item xs={12} sm={6} md={3}>
                <Card>
                    <CardContent>
                        <Box sx={cardGridProps}>
                            <Box sx={textContainerProps}>
                                <Typography color="textSecondary" gutterBottom>
                                    {daily ? t('appointments.paidIncome') : t('appointments.totalIncome')}
                                </Typography>
                                <Typography variant="h4">
                                    {formatCurrency(stats.PaidIncome)}
                                </Typography>
                            </Box>
                            <Box sx={{ ...iconContainerProps, color: 'success.main' }}>
                                <AttachMoney />
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            </Grid>
        )}
    </Grid>
);

export default AppointmentsStats;
